import { useMemo } from 'react';
import type { Email } from '@/types/email';

interface UseBulkSelectionConfig {
  visibleEmails: Email[];
  bulkSelection: Set<string>;
}

export function useBulkSelection({ visibleEmails, bulkSelection }: UseBulkSelectionConfig) {
  const visibleEmailIds = useMemo(
    () => visibleEmails.map((email) => email.id),
    [visibleEmails],
  );

  const allVisibleSelected = useMemo(
    () => visibleEmailIds.length > 0 && visibleEmailIds.every((id) => bulkSelection.has(id)),
    [visibleEmailIds, bulkSelection],
  );

  const hasBulkSelection = useMemo(() => bulkSelection.size > 0, [bulkSelection]);

  const selectedEmails = useMemo(
    () => visibleEmails.filter((email) => bulkSelection.has(email.id)),
    [visibleEmails, bulkSelection],
  );

  return {
    visibleEmailIds,
    allVisibleSelected,
    hasBulkSelection,
    selectedEmails,
  };
}
